var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-dialog", {
    attrs: {
      title: (_vm.form.id ? "编辑" : "新增") + "分类",
      width: "33%",
      visible: _vm.dialogVisible
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      },
      close: _vm.close
    }
  }, [_c("el-form", {
    ref: "ruleForm",
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      model: _vm.form,
      rules: _vm.rules,
      "label-position": "right",
      "label-width": "100px"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "中文名称",
      prop: "categoryZh"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入内容"
    },
    model: {
      value: _vm.form.categoryZh,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "categoryZh", $$v);
      },
      expression: "form.categoryZh"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "英文名称",
      prop: "categoryEn"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入内容"
    },
    model: {
      value: _vm.form.categoryEn,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "categoryEn", $$v);
      },
      expression: "form.categoryEn"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "繁体名称",
      prop: "categoryTw"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入内容"
    },
    model: {
      value: _vm.form.categoryTw,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "categoryTw", $$v);
      },
      expression: "form.categoryTw"
    }
  })], 1)], 1), _c("div", {
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      size: "small"
    },
    on: {
      click: function click($event) {
        _vm.dialogVisible = false;
      }
    }
  }, [_vm._v("取 消 ")]), _c("el-button", {
    attrs: {
      size: "small",
      type: "primary"
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v("确 定 ")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };